import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Space, Button, Row, Col, Image, Card, Popconfirm } from "antd";
import { I18N_NS } from "Config/i18n";
import { useState } from "react";
// import { Button } from "Components/General/Button";
import { useTranslation } from "react-i18next";

interface ViewpointInputProps {
  value?: API_BcfServerViewpoint[];
  onChange?: (value: API_BcfServerViewpoint[]) => void;
  onEnableViewpointAddMode: () => void;
}

export const ViewpointInput = ({ value = [], onChange, onEnableViewpointAddMode }: ViewpointInputProps) => {
  const { t } = useTranslation(I18N_NS.PROJECT);

  const [visiblePreviews, setVisiblePreviews] = useState<{ [key: string]: boolean }>({});

  const removeViewpoint = (index: number) => {
    const newValue = value.filter((_, idx) => idx !== index);
    onChange(newValue);
  };

  const handlePreviewVisibility = (key: string, visible: boolean) => {
    setVisiblePreviews((prev) => ({
      ...prev,
      [key]: visible,
    }));
  };

  return (
    <div id="viewpoint_input">
      <Space size="small" className="mb-md">
        <Button onClick={onEnableViewpointAddMode}>
          <span className="fa-stack relative" style={{ top: -4, left: -2 }}>
            <FontAwesomeIcon fixedWidth icon={["far", "camera"]} className="fa-stack" />
            <FontAwesomeIcon
              fixedWidth
              icon={["fas", "plus"]}
              className="fa-stack-1x"
              transform="right-16 down-5 shrink-4"
              // enableBackground={"#fff"}
            />
          </span>
        </Button>
      </Space>
      <Row gutter={10}>
        {value.map((item, idx) => (
          <Col sm={8} md={6} key={item.guid} className="mb-2 relative">
            <Card>
              <Popconfirm
                title={t("Are you sure?")}
                okText={t("Yes")}
                cancelText={t("No")}
                onConfirm={() => removeViewpoint(idx)}
              >
                <span onClick={() => removeViewpoint(idx)} className="viewpoint-delete">
                  <FontAwesomeIcon fixedWidth icon={["far", "trash-alt"]} />
                </span>
              </Popconfirm>
              <Image
                src={item.snapshot?.snapshot_data}
                preview={{
                  getContainer: () => document.getElementById("viewpoint_input"),
                  visible: visiblePreviews[item.guid] || false,
                  onVisibleChange: (visible) => handlePreviewVisibility(item.guid, visible),
                  // For some reason default close icon or CloseOutlined triggers submit for Form
                  closeIcon: (
                    <button
                      className="ant-image-preview-close"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handlePreviewVisibility(item.guid, false);
                      }}
                    >
                      <span role="img" aria-label="close" className="anticon anticon-close">
                        <svg
                          fill-rule="evenodd"
                          viewBox="64 64 896 896"
                          focusable="false"
                          data-icon="close"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          {/* eslint-disable-next-line max-len */}
                          <path d="M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"></path>
                        </svg>
                      </span>
                    </button>
                  ),
                }}
              />
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};
